/* eslint-disable react/prop-types */
import React, { useCallback, useMemo, useState } from 'react';
import Visibility from '../../components/Visibility';
import { getTrack, pureTrans } from '../../helpers';
import './style.scss';
import { DesktopContent, DesktopImage } from './Desktop';
import { MobileContent, MobileImage } from './Mobile';

const track = getTrack({ block: 9 });

const SOURCE = {
  mobile: [-0.12, 0, 0.24, 0.48],
  desktop: [-0.4, 0, 0.4, 0.8]
};
const TARGET = {
  mobile: [0, 1, 2, 3],
  desktop: [0, 1, 2, 3]
};

export function SuperLens() {
  const [mobile, setMobile] = useState(false);
  const [progress, setProgress] = useState(0);
  const { step } = useMemo(() => {
    if (mobile) {
      return {
        step: pureTrans(progress, SOURCE.mobile, TARGET.mobile, 0)
      };
    }
    return {
      step: pureTrans(progress, SOURCE.desktop, TARGET.desktop, 0)
    };
  }, [progress, mobile]);

  const handleUpdate = useCallback(
    (e, { calculations: { percentagePassed, width } }) => {
      setMobile(width <= 750);
      setProgress(percentagePassed);
    },
    [setProgress]
  );

  return (
    <Visibility offset={[-1000, 0]} onUpdate={handleUpdate} className="page-section inverted section-superlens" data-track={track}>
      <div className="sticky-content">
        {!mobile && <DesktopImage step={step} />}
        {!mobile && <DesktopContent step={step} />}
        {mobile && <MobileContent step={step} />}
        {mobile && <MobileImage step={step} />}
      </div>
    </Visibility>
  );
}
